import { render, staticRenderFns } from "./cooperation_unit.vue?vue&type=template&id=b2cba362&scoped=true&"
import script from "./cooperation_unit.vue?vue&type=script&lang=js&"
export * from "./cooperation_unit.vue?vue&type=script&lang=js&"
import style0 from "./cooperation_unit.vue?vue&type=style&index=0&id=b2cba362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cba362",
  null
  
)

export default component.exports